import Api from '../../shared/Api';
import ICalendar from '../calendar/ICalendar';

export default class StylingUserCalendarApi {
    static getCalendar(from: any, to: any) {
        let url =
            `/views/stylinguser-calendars/me` +
            '?fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static updateCalendar(calendar: ICalendar) {
        return new Api().put(`/views/stylinguser-calendars`, calendar);
    }

    static getCalendarPrintEvents(from: any, to: any) {
        let url =
            `/views/stylinguser-calendars/me/GetCalendarItemPrintEvents` +
            '?fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static unbookEvent(calendarItemId: number): any {
        return new Api().delete(`/views/stylinguser-booking/${calendarItemId}`);
    }

    static getSpecificStylingUserCalendarItem(stylingUserId: number, calendarItem: number) {
        return new Api().get('/views/stylinguser-calendars/items/GetCalendarItem', {
            stylingUserId: stylingUserId,
            itemId: calendarItem
        });
    }

    static createCalendarItem(item: any) {
        return new Api().post('/views/stylinguser-calendars/items', {
            stylingUserId: item.stylingUserId,
            item: item
        });
    }

    static deleteCalendarItem(item: any) {
        return new Api().delete('/views/stylinguser-calendars/items/' + item.id);
    }

    static updateCalendarItem(item: any) {
        return new Api().put('/views/stylinguser-calendars/items/', {
            stylingUserId: item.stylingUserId,
            item: item
        });
    }
}
